// extracted by mini-css-extract-plugin
export default {"isHighlighted":"y5lOwnUb5qWYMrsu9WW0"};